import { Button } from '@moda/om';
import React from 'react';
import { useReturn } from '../../../../hooks/useReturn';

interface Props {
  shipmentNumber: string;
}

export const RequestReturnPrintableLabelButton: React.FC<Props> = ({ shipmentNumber }) => {
  const { returnOrder } = useReturn(shipmentNumber);

  if (!returnOrder) return null;

  return (
    <Button
      className="ReturnInstructions__label-button"
      href={returnOrder?.attributes.shippingLabel}
      target="_blank"
      rel="noopener noreferrer"
    >
      PRINT SHIPPING LABEL
    </Button>
  );
};
